export enum JobWorkStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
}

export class VendorStatusUpdateReq {
  id: number;
  jobWorkStatus: JobWorkStatus;
  vendorId: number;

  constructor(id: number, jobWorkStatus: JobWorkStatus, vendorId: number) {
    this.id = id;
    this.jobWorkStatus = jobWorkStatus;
    this.vendorId = vendorId;
  }
}
